import { SHOW_MOBILE_MENU, HIDE_MOBILE_MENU } from '../types';

export const showMobileMenu = () => ({
    type: SHOW_MOBILE_MENU
});

export const hideMobileMenu = () => ({
    type: HIDE_MOBILE_MENU
});